const data = {
  counterText: '名額有限',
  loading: '載入中',
  next: '下一步',
  previous: '以前',
  smCounterText: '名额有限',
};

export default data;
